import Alpine from 'alpinejs';
import { FlatEntry, citiesFlatResults, storeLocatorAutocomplete } from '../../scripts/helpers/storeLocator';
import { AutocompleteSelectedDetail } from './types';

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('newAutocomplete', (shopOnly = false) => ({
        results: [] as FlatEntry[],
        focusedIndex: -1,
        modal: false,
        loading: false,
        noResults: false,
        _sourceInput: null as HTMLInputElement | null,

        init(): void {
            const input = this.$el.querySelector('input') as HTMLInputElement | null;
            if (!input) return;
            let debounceTimer: ReturnType<typeof setTimeout>;
            input.addEventListener('input', (e: Event) => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => this.fetchCities(e), 300);
            });
            input.addEventListener('keydown', (e: KeyboardEvent) => this.handleKeydown(e));
            input.addEventListener('click', () => this.openModal());
        },

        fetchCities(event: Event): void {
            const input = event.target as HTMLInputElement;
            this._sourceInput = input;
            const query = input.value.trim().split(' ')[0];
            if (!query) {
                this.closeModal();
                this.results = [];
                this.noResults = false;
                return;
            }
            this.loading = true;
            storeLocatorAutocomplete(query, !!shopOnly)
                .then((cities) => {
                    this.results = citiesFlatResults(cities);
                    this.focusedIndex = -1;
                    this.noResults = this.results.length === 0;
                    this.modal = this.results.length > 0;
                })
                .catch(() => {
                    this.results = [];
                    this.noResults = true;
                    this.modal = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleKeydown(event: KeyboardEvent): void {
            if (event.key === 'ArrowDown') {
                if (!this.modal) return;
                event.preventDefault();
                this.focusedIndex = Math.min(this.focusedIndex + 1, this.results.length - 1);
                this.scrollFocusedIntoView();
            } else if (event.key === 'ArrowUp') {
                if (!this.modal) return;
                event.preventDefault();
                this.focusedIndex = Math.max(this.focusedIndex - 1, -1);
                this.scrollFocusedIntoView();
            } else if (event.key === 'Escape') {
                this.closeModal();
            } else if (event.key === 'Enter' && this.modal && this.focusedIndex >= 0) {
                event.preventDefault();
                this.selectItem(this.results[this.focusedIndex]);
            }
        },

        selectItem(entry: FlatEntry): void {
            if (this._sourceInput) {
                this._sourceInput.value = entry.zip + ' ' + entry.item.nom;
            }
            const detail: AutocompleteSelectedDetail = {
                zip: entry.zip,
                city: entry.item.nom,
                item: entry.item,
                cpIndex: entry.cpIndex,
                input: this._sourceInput,
            };
            this.$dispatch('autocomplete-selected', detail);
            this.closeModal();
        },

        scrollFocusedIntoView(): void {
            this.$nextTick(() => {
                const focused = this.$el.querySelector('[data-autocomplete-focused]');
                focused?.scrollIntoView({ block: 'nearest' });
            });
        },

        closeModal(): void {
            this.modal = false;
        },

        openModal(): void {
            if (this.results.length) {
                this.modal = true;
            }
        },
    }));
});
